import React from 'react';
import { withStyles } from '@material-ui/core';
import { Tween } from 'react-gsap';
import NavCard from './NavCard';

const styles = theme => ({
  navigation: {
    paddingTop: theme.spacing.unit * 3,
    paddingLeft: theme.spacing.unit * 12,
    paddingRight: theme.spacing.unit * 3,
    position: 'fixed',
    bottom: 0,
    top: 'auto',
    left: '50vw',
    marginLeft: '-300px',
    right: 'auto',
    display: 'flex',
    height: 140,
    width: 590,
    zIndex: 100,
    overflow: 'hidden',
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing.unit,
      paddingLeft: theme.spacing.unit * 6,
      marginLeft: '-160px',
      height: 80,
      width: 320
    }
  }
});

const Navigation = withStyles(styles)(
  class extends React.PureComponent {
    render() {
      const { classes } = this.props;

      return (
        <Tween
          from={{ bottom: '-200px' }}
          to={{ bottom: '0px' }}
          delay={3}
          duration={0.5}
          // ease="Back.easeInOut"
        >
          <div className={classes.navigation}>
            <NavCard
              zIndexVal={1}
              rotate={-30}
              link="about"
              name="about"
              image="git-pull"
            />
            <NavCard
              zIndexVal={2}
              rotate={-15}
              link="creators"
              name="creators"
              image="profit-share"
            />
            <NavCard
              zIndexVal={3}
              rotate={0}
              link="manual"
              name="manual"
              image="medic"
            />
            <NavCard
              zIndexVal={4}
              rotate={15}
              link="download"
              name="download"
              image="self-dev-time"
            />
            <NavCard
              zIndexVal={5}
              rotate={30}
              link="feedback"
              name="feedback"
              image="speciality-coffee"
            />
          </div>
        </Tween>
      );
    }
  }
);

export default Navigation;
